import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SystemSetting, SystemSettingCreate, SystemSettingFilter } from '../data/systemSetting';

export function createSystemSettingService(client: AxiosInstance) {
  return createCrudService<SystemSetting, SystemSettingCreate, SystemSettingFilter>(
    client,
    '/platform/SystemSetting',
    'id',
  );
}

export type SystemSettingService = CrudService<SystemSetting, SystemSettingCreate, SystemSettingFilter>;
